<template>
  <div>
    <div :class="'speakerPresentationContainer'+(data.isFullScreen?' isFullScreened':'')">
      <div class="headerText" v-if="!data.isFullScreen">{{ $t("Presentations") }}</div>
      <div
        :class="'speakerPresentation'+(presentation.instanceData.expandSummary?' active':'')"
        v-for="(presentation, index) in data.items"
        :key="index"
        @click="presentationClicked(presentation.parsedStart)"
      >
        <div class="textRow" v-if="!data.isFullScreen">
          <div class="imgContainer">
            <div
              class="loadingContainer"
              :style="
                presentation.instanceData.imgSource == null ? 'display:flex' : 'display:none'
              "
            >
              <div class="loader"></div>
            </div>
            <img
              :src="presentation.instanceData.imgSource"
              :style="
                presentation.instanceData.imgSource == null ? 'display:none' : 'display:flex'
              "
            />
          </div>
          <div class="textContainer">
            <div class="titleText">
              {{ presentation.instanceData.title }}
            </div>
            <div class="speakerNameText">
              {{ presentation.instanceData.speakerName }}
            </div>
            <div class="timeText">
              {{ presentation.startTime }}
              <span v-if="!presentation.isActive"
                >({{ presentation.timeDifference }})</span
              ><span v-if="presentation.isActive"
                >({{ presentation.remainingTime }})</span
              >
            </div>
          </div>
        </div>
        <div class="summaryRow" v-if="presentation.instanceData.summaryFile != null">
          <div v-if="!data.isFullScreen" class="summaryHeader" @click="expandSummary(presentation, $event)">
            <div class="summaryText">{{ $t("Summary") }}</div>
            <div class="arrowContainer" v-if="!data.isisFullScreen">
              <fa-icon
                :icon="['fas', 'chevron-down']"
                v-if="!presentation.instanceData.expandSummary"
              ></fa-icon>
              <fa-icon
                :icon="['fas', 'chevron-up']"
                v-if="presentation.instanceData.expandSummary"
              ></fa-icon>
            </div>
          </div>
          <div class="summaryBody">
            <div class="header" v-if="data.isFullScreen === true">
              <slot name="crossButton"></slot>
            </div>
            <iframe :src="'.'+presentation.instanceData.summaryFile" frameborder="0" style="overflow:hidden;height:100%;width:100%" height="100%" width="100%"/>
            
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "../scss/presentations.css";
import timeMixin from "../mixins/timeMixin";
import Vue from "vue";

export default {
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      scrollSaveCount: 0,
    };
  },
  created() {
    this.data.items.forEach((element) => {
      element.parsedStart = this.convertHoursMinsSecsToSeconds(
        element.instanceData.startTime
      );
      element.parsedEnd = this.convertHoursMinsSecsToSeconds(element.instanceData.endTime);
      Vue.set(element, "remainingTime", "");
      Vue.set(
        element,
        "timeDifference",
        this.convertSecondsToHourMinsSecs(
          element.parsedEnd - element.parsedStart
        )
      );
      Vue.set(element, "isActive", false);
    });
  },
  methods: {
    runFirstLoad() {
      this.onVisible();
    },
    presentationClicked(startTime) {
      this.$root.$emit("seekVideo", startTime);
      this.$root.$emit("playVideo");
    },
    async getVideoImageAsynced(index) {
      var clonedVideo = document.querySelector("video").cloneNode(true);
      clonedVideo.addEventListener("seeked", async () => {
        this.data[index].imgSource = await this.capture(clonedVideo);
      });
      clonedVideo.currentTime = this.convertHoursMinsSecsToSeconds(
        this.data[index].captureImageAtTime
      );
    },
    process(time) {
      this.data.items.forEach((element) => {
        if (time > element.parsedStart && time < element.parsedEnd) {
          element.isActive = true;
          element.remainingTime = this.convertSecondsToHourMinsSecs(
            element.parsedEnd - time
          );
        } else {
          element.isActive = false;
        }
      });
    },
    capture(video) {
      return new Promise((resolve, reject) => {
        var canvas = document.createElement("canvas");
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        canvas
          .getContext("2d")
          .drawImage(video, 0, 0, video.videoWidth, video.videoHeight);
        canvas.toBlob((blob) => {
          if (blob == null) reject();
          else resolve(window.URL.createObjectURL(blob));
        });
      });
    },
    onVisible() {
      // this.data.forEach(async (item, index) => {
      //   if (item.captureImageAtTime != null)
      //     await this.getVideoImageAsynced(index);
      // });
    },
    expandSummary(presentation, event) {
      presentation.instanceData.expandSummary = !presentation.instanceData.expandSummary;
      event.stopPropagation();
      console.log(event.target.nextElementSibling.children[0].contentWindow.document.body.scrollHeight)
      this.$nextTick(()=>{
        event.target.nextElementSibling.style.height=event.target.nextElementSibling.children[0].contentWindow.document.body.scrollHeight+"px";
        this.$parent.resize();
      })      
    }
  },
  mixins: [timeMixin],
};
</script>
